module.exports = __webpack_public_path__ + "img/loading4.gif";